module.exports = __webpack_public_path__ + "img/ssa-3.0aa1a50a.svg";